import React from "react";
import { Swords } from "lucide-react";
import NarrativeAssessmentCardBase from "./NarrativeAssessmentCardBase";

const CompetitorAnalysisNarrativeAssessmentViewer = ({ markdown = "" }) => (
  <NarrativeAssessmentCardBase
    markdown={markdown}
    Icon={Swords}
    subtitle="Competitive pressure, visibility gap, and positioning risk"
    badge="COMPETITOR"
    theme={{
      cardBg: "#fef2f2",
      cardBorder: "#fecaca",
      heroBg: "#fee2e2",
      heroBorder: "#fca5a5",
      badgeBg: "rgba(239, 68, 68, 0.12)",
      badgeBorder: "#ef4444",
      iconColor: "#b91c1c",
      dotColor: "#ef4444",
    }}
  />
);

export default CompetitorAnalysisNarrativeAssessmentViewer;
